/**
 * Oferta de montagem no carrinho (sections/assembly-offer.liquid).
 *
 * Tudo fica dentro desta função para não colidir com as variáveis globais
 * (cidades_75, getAssemblyPrice...) que o main-product.liquid declara na página de produto.
 */
(() => {
  if (customElements.get('assembly-offer')) return;

  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------------------------------
   * Regra de preço copiada de sections/main-product.liquid
   * (bloco "Script Calculo de Frete e Montagem").
   * Única adaptação: calculateAssemblyPrice lê o preço do produto do
   * carrinho (em centavos) em vez de {{ product.price }}.
   * ------------------------------------------------------------------ */
  let precoProdutoCentavos = 0;

  function calculateAssemblyPrice() {
    const productPrice = precoProdutoCentavos / 100
    const assemblyPrice = productPrice * 0.090
    return assemblyPrice <= 90 ? 90 : assemblyPrice
  }

  let cidades_75 = [
    'Magé','Barra de Guaratiba','Pedra de Guaratiba','Guaratiba','Sepetiba','Duque de Caxias'
  ]

  let cidades_bairros_75 = [
    'Nova Iguaçu'
  ]

  let bairros_75 = [
    'Jardim Cachoeira','Tinguá','Vila de Cava','Km 32','Jaceruba','Rancho Novo','Campo Alegre'
  ]

  let cidades_150 = [
    'Petrópolis','Areal','Maricá','Mendes','Miguel Pereira','Japeri','Paracambi',
    'Guapimirim','Paulo de Frontin','Itaguaí','Piraí','Queimados',
    'Itaboraí','Rio Bonito','Saquarema','Seropédica','Tanguá','Teresópolis'
  ]

  let cidades_200 = [
    'Resende','Angra dos Reis','Araruama','Barra do Piraí','Vassouras','Barra Mansa','Nova Friburgo',
    'Paraíba do Sul','Cachoeiras de Macacú','Casimiro de Abreu','Comendador Levy Gasparian',
    'Paty do Alferes','Mangaratiba','Valença','Pinheiral','Iguaba Grande','Porto Real','Quatis','Rio Claro',
    'São José do Vale do Rio Preto','Silva Jardim','Três Rios','Valença','Barra do Piraí','Vassouras',
    'Volta Redonda'
  ]

  let cidades_250 = [
    'Macuco','Armação dos Búzios','Mauá','Arraial do Cabo','Rio das Ostras','Cabo Frio','Cordeiro',
    'Itatiaia','Macaé','São Pedro da Aldeia','Sapucaia'
  ]

  let cidades_300 = [
    'Miracema','Cambuci','Cantagalo','Paraty','Santa Maria Madalena','Itaocara',
    'Santo Antônio de Pádua','São Fidelis','Laje do Muriaé','Conceição de Macabu','Trajano de Moraes',
    'Aperibé','Quissamã'
  ]

  let cidades_350 = [
    'Campos dos Goytacazes','Cardoso Moreira','Itaperuna','Italva','São Francisco de Itabapoana','São João da Barra'
  ]
  function getAssemblyPrice(city, state, neighborhood) {
    if (state !== 'RJ'){
        return // montagem não disponível
    }

    const assemblyPrice = calculateAssemblyPrice()

   if(neighborhood == 'Parque Mambucaba (Mambucaba)'){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 300 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(300 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 300, totalPrice: assemblyPrice}
    }

    if(neighborhood == 'Passa Três'){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 150 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(150 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 150, totalPrice: assemblyPrice}
    }

    if (cidades_75.includes(city) ){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 75 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(75 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 75, totalPrice: assemblyPrice}
    }

    if (cidades_bairros_75.includes(city) && bairros_75.includes(neighborhood)) {
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 75 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(75 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 75, totalPrice: assemblyPrice}
    }

    if (cidades_150.includes(city)){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 150 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(150 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 150, totalPrice: assemblyPrice}
    }

    if (cidades_200.includes(city)){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 200 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(200 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 200, totalPrice: assemblyPrice}
    }

    if (cidades_250.includes(city)){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 250 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(250 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 250, totalPrice: assemblyPrice}
    }

    if (cidades_300.includes(city)){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 300 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(300 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 300, totalPrice: assemblyPrice}
    }

    if (cidades_350.includes(city)){
        return {message: `Serviço de montagem - Deslocamento da equipe R$ 350 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(350 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 350, totalPrice: assemblyPrice}
    }

    if (city == 'Niterói'){
        return {message: `Serviço de montagem - R$ ${ parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}`, totalPrice: assemblyPrice}
    }

    if (city !== 'São Gonçalo'){
        return {message: `Serviço de montagem - R$ ${ parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}`, totalPrice: assemblyPrice}
    }

    if (city !== 'Belford Roxo'){
        return {message: `Serviço de montagem - R$ ${ parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}`, totalPrice: assemblyPrice}
    }

    if (city !== 'Rio de Janeiro'){
      return {message: `Serviço de montagem - Deslocamento da equipe R$ 250 + Montagem R$ ${parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}. Total adicional: R$ ${parseFloat(250 + assemblyPrice).toFixed(2).replace('.', ',')}`, displacement: 250, totalPrice: assemblyPrice}
    }
    return {message: `Serviço de montagem - R$ ${ parseFloat(assemblyPrice).toFixed(2).replace('.', ',')}`, totalPrice: assemblyPrice}
  }

  /* ------------------------------------------------------------------
   * Fim do trecho copiado.
   * ------------------------------------------------------------------ */

  function precoMontagem(precoCentavos, cidade, uf, bairro) {
    precoProdutoCentavos = precoCentavos;
    return getAssemblyPrice(cidade, uf, bairro);
  }

  // Mesmo formato gravado pelo main-product.liquid nas propriedades do item ("R$90,00").
  // Sem ponto de milhar: o app de cobrança lê "R$1.125,82" como R$ 1,13.
  const formatar = (valor) => `R$${parseFloat(valor).toFixed(2).replace('.', ',')}`;

  // Para mostrar ao cliente, com ponto de milhar ("R$1.657,00").
  const formatarTela = (valor) => `R$${Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const mdc = (a, b) => (b ? mdc(b, a % b) : a);

  /**
   * Tenta escrever "total" como soma de (parte x quantidade) de cada item, com partes inteiras
   * o mais parecidas possível. Devolve as partes ou null se não houver combinação exata.
   */
  function combinarPartes(total, quantidades) {
    // Sem divisor comum não existe combinação exata (ex.: total ímpar e só quantidades pares).
    if (total % quantidades.reduce(mdc) !== 0) return null;

    const unidades = quantidades.reduce((soma, q) => soma + q, 0);

    for (let base = Math.floor(total / unidades); base >= 0; base -= 1) {
      const resto = total - base * unidades;

      // Soma de moedas: com quais quantidades se forma o resto (+1 real por unidade no item escolhido).
      const item = new Array(resto + 1).fill(-1);
      item[0] = -2;
      for (let valor = 1; valor <= resto; valor += 1) {
        for (let i = 0; i < quantidades.length; i += 1) {
          if (quantidades[i] <= valor && item[valor - quantidades[i]] !== -1) {
            item[valor] = i;
            break;
          }
        }
      }

      if (item[resto] !== -1) {
        const partes = quantidades.map(() => base);
        for (let valor = resto; valor > 0; valor -= quantidades[item[valor]]) {
          partes[item[valor]] += 1;
        }
        return partes;
      }
    }

    return null;
  }

  /**
   * Divide o valor da montagem (em reais inteiros) entre os itens, por unidade.
   * O app de cobrança multiplica o valor de cada item pela quantidade e ignora centavos,
   * então as partes são inteiras e a soma (parte x quantidade) fecha no total.
   * Quando não existe combinação exata (ex.: um item com quantidade 2 e total ímpar),
   * usa o valor possível mais próximo do total (em empate, o menor).
   */
  function dividirPorUnidade(total, quantidades) {
    const exato = combinarPartes(total, quantidades);
    if (exato) return exato;

    const passo = quantidades.reduce(mdc);
    const abaixo = Math.floor(total / passo) * passo;
    const acima = abaixo + passo;
    const alvos = total - abaixo <= acima - total ? [abaixo, acima] : [acima, abaixo];

    for (const alvo of alvos) {
      const partes = combinarPartes(alvo, quantidades);
      if (partes) return partes;
    }

    for (let alvo = total - 1; alvo >= 0; alvo -= 1) {
      const partes = combinarPartes(alvo, quantidades);
      if (partes) return partes;
    }

    return quantidades.map(() => 0);
  }

  // Botões de pagamento do carrinho (gaveta e página /cart).
  const SELETOR_PAGAMENTO = 'button[name="checkout"], input[type="submit"][name="checkout"]';

  // Se a consulta demorar mais que isso, o cliente segue para o pagamento sem a oferta.
  const LIMITE_CONSULTA_MS = 5000;

  class AssemblyOffer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.itens = this.querySelector('.js-assembly-offer-items');
      this.passoPergunta = this.querySelector('[data-step="pergunta"]');
      this.passoCep = this.querySelector('[data-step="cep"]');
      this.form = this.querySelector('.js-assembly-offer-form');
      this.inputCep = this.querySelector('#AssemblyOfferCep');
      this.botaoCalcular = this.querySelector('.js-assembly-offer-calc');
      this.botaoAdicionar = this.querySelector('.js-assembly-offer-add');
      this.resultado = this.querySelector('.js-assembly-offer-result');

      this.aoClicar = (evt) => this.interceptarClique(evt);
      this.aoEnviar = (evt) => this.interceptarEnvio(evt);
      this.aoVoltar = (evt) => {
        // Voltando do checkout pelo botão "voltar" do navegador, a página é restaurada da memória.
        if (evt.persisted) this.seguindo = false;
      };

      // No editor de temas o botão de pagamento funciona normalmente.
      if (!this.hasAttribute('data-design-mode')) {
        document.addEventListener('click', this.aoClicar, true);
        document.addEventListener('submit', this.aoEnviar, true);
        window.addEventListener('pageshow', this.aoVoltar);
      }

      // X: fecha e o cliente continua no carrinho.
      this.querySelector('.js-assembly-offer-close').addEventListener('click', () => this.fechar());

      // "Não, seguir para o pagamento" (nas duas etapas).
      this.querySelectorAll('.js-assembly-offer-decline').forEach((botao) => {
        botao.addEventListener('click', () => this.recusar());
      });

      // Esc: mesmo comportamento do X.
      this.dialog.addEventListener('cancel', (evt) => {
        evt.preventDefault();
        this.segurarEscDoCarrinho();
        this.fechar();
      });

      // Clique fora da janela (no fundo escurecido): mesmo comportamento do X.
      this.dialog.addEventListener('click', (evt) => {
        if (evt.target === this.dialog) this.fechar();
      });

      this.querySelector('.js-assembly-offer-yes').addEventListener('click', () => this.aceitar());
      this.form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        this.calcular();
      });
      this.botaoAdicionar.addEventListener('click', () => this.adicionar());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.aoClicar, true);
      document.removeEventListener('submit', this.aoEnviar, true);
      window.removeEventListener('pageshow', this.aoVoltar);
    }

    /**
     * Segura o clique em "Ir para pagamento" para perguntar sobre a montagem antes.
     */
    interceptarClique(evt) {
      if (this.seguindo || !evt.target.closest) return;

      const botao = evt.target.closest(SELETOR_PAGAMENTO);
      if (!botao || botao.disabled) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.verificar(botao);
    }

    /**
     * Cobre o envio do formulário do carrinho por outro caminho que não o clique
     * (por exemplo, form.requestSubmit feito por outro script).
     */
    interceptarEnvio(evt) {
      if (this.seguindo) return;

      const botao = evt.submitter;
      if (!botao || !botao.matches || !botao.matches(SELETOR_PAGAMENTO)) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.verificar(botao);
    }

    /**
     * Busca os produtos do carrinho que podem receber montagem e ainda não têm.
     * Sem produtos elegíveis (ou se algo falhar), segue direto para o pagamento.
     */
    async verificar(botao) {
      if (this.verificando || this.dialog.open) return;
      this.verificando = true;
      this.botaoPagamento = botao;
      botao.classList.add('is-loading');
      botao.setAttribute('aria-busy', 'true');

      const controle = new AbortController();
      const limite = setTimeout(() => controle.abort(), LIMITE_CONSULTA_MS);

      try {
        const resposta = await fetch(`${raiz}?sections=${this.dataset.sectionId}`, { signal: controle.signal });
        if (!resposta.ok) throw new Error(`sections ${resposta.status}`);

        const secoes = await resposta.json();
        const html = new DOMParser().parseFromString(secoes[this.dataset.sectionId] || '', 'text/html');
        const novaLista = html.querySelector('.js-assembly-offer-items');
        const chaves = novaLista
          ? [...novaLista.querySelectorAll('[data-key]')].map((item) => item.dataset.key)
          : [];

        if (!chaves.length) {
          this.seguir();
          return;
        }

        this.itens.innerHTML = novaLista.innerHTML;
        this.reiniciar();
        this.dialog.showModal();
        this.querySelector('.js-assembly-offer-yes').focus();
      } catch (erro) {
        console.error('Oferta de montagem:', erro); // eslint-disable-line
        this.seguir();
      } finally {
        clearTimeout(limite);
        botao.classList.remove('is-loading');
        botao.removeAttribute('aria-busy');
        this.verificando = false;
      }
    }

    /**
     * Continua para o pagamento repetindo o clique original, agora sem interceptar.
     */
    seguir() {
      this.seguindo = true;

      const botao = this.botaoPagamento && this.botaoPagamento.isConnected
        ? this.botaoPagamento
        : document.querySelector(SELETOR_PAGAMENTO);

      if (botao && !botao.disabled) {
        botao.click();
      } else {
        window.location.href = `${raiz}checkout`;
      }
    }

    reiniciar() {
      this.passoPergunta.hidden = false;
      this.passoCep.hidden = true;
      this.resultado.innerHTML = '';
      this.botaoAdicionar.hidden = true;
      this.carregando(this.botaoAdicionar, false);
      this.calculo = null;
      this.querySelectorAll('.js-assembly-offer-error').forEach((el) => {
        el.hidden = true;
        el.textContent = '';
      });
    }

    itensSelecionados() {
      return [...this.itens.querySelectorAll('[data-key]')].filter((item) => {
        const marcador = item.querySelector('.js-assembly-offer-check');
        return !marcador || marcador.checked;
      });
    }

    mostrarErro(passo, mensagem) {
      const el = passo.querySelector('.js-assembly-offer-error');
      el.textContent = mensagem;
      el.hidden = !mensagem;
    }

    carregando(botao, ativo) {
      botao.disabled = ativo;
      botao.classList.toggle('is-loading', ativo);
      botao.setAttribute('aria-busy', ativo ? 'true' : 'false');
    }

    /**
     * A janela fecha no keydown do Esc e o foco volta para o carrinho, que fecha no keyup.
     * Segura só esse keyup para o carrinho continuar aberto.
     */
    segurarEscDoCarrinho() {
      const segurar = (evt) => {
        if (evt.key !== 'Escape') return;
        evt.stopPropagation();
        document.removeEventListener('keyup', segurar, true);
      };

      document.addEventListener('keyup', segurar, true);
      setTimeout(() => document.removeEventListener('keyup', segurar, true), 1000);
    }

    // X, Esc ou clique fora: fecha e o cliente continua no carrinho.
    fechar() {
      this.dialog.close();
    }

    // "Não": segue para o pagamento sem montagem.
    recusar() {
      this.dialog.close();
      this.seguir();
    }

    aceitar() {
      if (!this.itensSelecionados().length) {
        this.mostrarErro(this.passoPergunta, 'Selecione pelo menos um produto.');
        return;
      }

      this.mostrarErro(this.passoPergunta, '');
      this.passoPergunta.hidden = true;
      this.passoCep.hidden = false;
      this.inputCep.focus();
    }

    async calcular() {
      const cep = this.inputCep.value.replace(/\D/g, '');
      this.resultado.innerHTML = '';
      this.botaoAdicionar.hidden = true;
      this.calculo = null;

      if (cep.length !== 8) {
        this.mostrarErro(this.passoCep, 'Digite um CEP válido, com 8 números.');
        this.inputCep.focus();
        return;
      }

      this.mostrarErro(this.passoCep, '');
      this.carregando(this.botaoCalcular, true);

      let endereco;
      let deslocamentoJaNoPedido = false;
      try {
        const resposta = await fetch(`https://viacep.com.br/ws/${cep}/json`, { method: 'GET' });
        endereco = await resposta.json();

        // O deslocamento é cobrado uma vez por pedido: se algum item já tem montagem com deslocamento
        // (por exemplo, adicionada na página do produto), não cobra de novo.
        const carrinho = await (await fetch(`${raiz}cart.js`)).json();
        deslocamentoJaNoPedido = carrinho.items.some((i) => i.properties
          && i.properties._assembly === 'on' && i.properties.Deslocamento);
      } catch (erro) {
        this.mostrarErro(this.passoCep, 'Não foi possível consultar o CEP. Tente novamente.');
        return;
      } finally {
        this.carregando(this.botaoCalcular, false);
      }

      if (!endereco || endereco.erro) {
        this.mostrarErro(this.passoCep, 'CEP não encontrado. Confira o número e tente novamente.');
        return;
      }

      const selecionados = this.itensSelecionados().map((item) => ({
        chave: item.dataset.key,
        unidade: Number(item.dataset.unitPrice) || 0,
        quantidade: Number(item.dataset.qty) || 1
      }));

      // Montagem do pedido: regra do main-product aplicada sobre o valor dos produtos marcados
      // (preço x quantidade). Até R$ 1.000,00 dá R$ 90,00; acima disso, 9%.
      const valorProdutos = selecionados.reduce((soma, l) => soma + l.unidade * l.quantidade, 0);
      const preco = precoMontagem(valorProdutos, endereco.localidade, endereco.uf, endereco.bairro);

      if (!preco) {
        this.resultado.innerHTML = '<p class="assembly-offer__unavailable">Serviço de montagem indisponível para a sua região</p>';
        return;
      }

      const totalMontagem = preco.totalPrice;
      const partes = dividirPorUnidade(Math.floor(totalMontagem), selecionados.map((l) => l.quantidade));
      const calculo = selecionados.map((linha, i) => ({ ...linha, porUnidade: partes[i] }));

      // O deslocamento depende só do endereço e entra uma vez por pedido.
      const deslocamentoRegiao = preco.displacement || 0;
      const deslocamento = deslocamentoJaNoPedido ? 0 : deslocamentoRegiao;

      const linhaMontagem = `<div><span>Montagem</span><span>${formatarTela(totalMontagem)}</span></div>`;

      let linhaDeslocamento = '';
      if (deslocamento) {
        linhaDeslocamento = `<div><span>Deslocamento da equipe</span><span>${formatarTela(deslocamento)}</span></div>`;
      } else if (deslocamentoRegiao) {
        linhaDeslocamento = '<div><span>Deslocamento da equipe</span><span>Já incluído no pedido</span></div>';
      }

      this.resultado.innerHTML = `
        <div class="assembly-offer__table">
          ${linhaMontagem}
          ${linhaDeslocamento}
          <div class="assembly-offer__total"><span>Total:</span><span>${formatarTela(totalMontagem + deslocamento)}</span></div>
        </div>
        <p class="assembly-offer__note">* Montagem em até 2 dias úteis após a entrega.</p>
      `;

      this.calculo = calculo;
      this.deslocamento = deslocamento;
      this.botaoAdicionar.hidden = false;
      this.botaoAdicionar.focus();
    }

    /**
     * Grava a montagem nos itens marcados do mesmo jeito que a página de produto
     * (propriedades _assembly = "on", Montagem por unidade e, só no primeiro item, Deslocamento)
     * e segue para o pagamento.
     */
    async adicionar() {
      if (!this.calculo) return;

      this.mostrarErro(this.passoCep, '');
      this.carregando(this.botaoAdicionar, true);

      try {
        for (const linha of this.calculo) {
          const carrinho = await (await fetch(`${raiz}cart.js`)).json();
          const item = carrinho.items.find((i) => i.key === linha.chave);
          if (!item) continue;

          const properties = { ...(item.properties || {}) };
          properties._assembly = 'on';
          // Parte de cada unidade: o app multiplica pela quantidade do item.
          properties.Montagem = formatar(linha.porUnidade);
          // Deslocamento só no primeiro item: é cobrado uma vez por pedido.
          const levaDeslocamento = this.deslocamento > 0;
          if (levaDeslocamento) {
            properties.Deslocamento = formatar(this.deslocamento);
          } else {
            delete properties.Deslocamento;
          }

          const resposta = await fetch(`${raiz}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: item.quantity, properties })
          });
          if (!resposta.ok) throw new Error(`cart/change ${resposta.status}`);

          // Já gravado: se algo falhar depois e o cliente tentar de novo, não entra em outro item.
          if (levaDeslocamento) this.deslocamento = 0;
        }
      } catch (erro) {
        console.error('Oferta de montagem:', erro); // eslint-disable-line
        this.carregando(this.botaoAdicionar, false);
        this.mostrarErro(this.passoCep, 'Não foi possível adicionar a montagem. Tente novamente.');
        return;
      }

      // O carrinho já está atualizado no servidor; o formulário da página ficou com dados antigos,
      // então o pagamento é aberto direto pelo endereço de checkout.
      this.seguindo = true;
      window.location.href = `${raiz}checkout`;
    }
  }

  customElements.define('assembly-offer', AssemblyOffer);
})();
